// Category groups for the landing page's SHOP BY tiles and the catalog's
// ?cat= filter. The inventory's `category` field is empty across the live
// stock, so the group is read from the title (and the field, when it is ever
// filled), the way detectShippingProfile in shippingCategories.js reads the
// shipping size. The LAST keyword in the text wins: titles name the garment
// last ("Denim Jacket", "Leather Flares", "Bootcut Jeans"), so the trailing
// noun is the item, and earlier hits are usually materials or styles.

// (2026-09-30: fleece, sweat(s), geobasket, ramone, clog, slip on, dogtag,
// hood and balaclava added, for titles that named no group or the wrong one:
// "Short Tongue Geobaskets" read as BOTTOMS; the catalog's SIZE filter now
// groups sizes by these types, so a wrong type puts a shoe size under
// BOTTOMS. "hood" does not catch "hoodie": the word has to end there.)
export const CATEGORY_GROUPS = [
  {
    key: "tops",
    label: "Tops",
    pattern: /\b(tee|t-shirt|tshirt|shirt|sweatshirt|sweater|hoodie|hoody|longsleeve|long sleeve|knit|cardigan|vest|jacket|coat|blazer|parka|bomber|blouson|anorak|top|polo|tank|pullover|crewneck|turtleneck|fleece)s?\b/gi,
  },
  {
    key: "bottoms",
    label: "Bottoms",
    pattern: /\b(jean|denim|pant|trouser|short|flare|cargo|skirt|legging|sweatpant|sweat|jogger|chino|slack)s?\b/gi,
  },
  {
    key: "shoes",
    label: "Shoes",
    pattern: /\b(sneaker|boot|shoe|loafer|derby|derbies|sandal|slide|mule|trainer|runner|heel|oxford|creeper|geobasket|ramone|clog|slip on|slip-on|slipon)s?\b/gi,
  },
  {
    key: "accessories",
    label: "Accessories",
    pattern: /\b(belt|bracelet|necklace|ring|chain|bag|wallet|hat|cap|beanie|scarf|glove|sunglasses|earring|pendant|keychain|cardholder|card holder|pouch|watch|brooch|pin|tie|cuff|choker|charm|tote|backpack|dogtag|dog tag|hood|balaclava)s?\b/gi,
  },
];

export const CATEGORY_BY_KEY = Object.fromEntries(CATEGORY_GROUPS.map((g) => [g.key, g]));

// The group key for an item, or null when nothing in its text names one.
export function categoryOf(item) {
  if (!item) return null;
  const text = `${item.category || ""} ${item.title || ""}`.toLowerCase();
  let best = null;
  let bestAt = -1;
  for (const group of CATEGORY_GROUPS) {
    group.pattern.lastIndex = 0;
    let m;
    let last = -1;
    while ((m = group.pattern.exec(text))) last = m.index;
    if (last > bestAt) {
      bestAt = last;
      best = group.key;
    }
  }
  return best;
}
